"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMessageRead = exports.IMessageSecure = exports.IMessageGenerated = exports.IMessageType = void 0;
var IMessageType;
(function (IMessageType) {
    IMessageType["INCOMING_MESSAGES_IS_ASSIGNED_INCOMING"] = "incoming";
    IMessageType["OUTGOING_MESSAGE_IS_ASSIGNED_OUTGOING"] = "outgoing";
})(IMessageType = exports.IMessageType || (exports.IMessageType = {}));
var IMessageGenerated;
(function (IMessageGenerated) {
    IMessageGenerated[IMessageGenerated["MESSAGE_WAS_AUOMATICALLY_GENERATED_AND_A_VALUE_OF__MEANS_IT_WAS_MANUALLY_GENERATED_0"] = 0] = "MESSAGE_WAS_AUOMATICALLY_GENERATED_AND_A_VALUE_OF__MEANS_IT_WAS_MANUALLY_GENERATED_0";
    IMessageGenerated[IMessageGenerated["MANUALLY_GENERATED_1"] = 1] = "MANUALLY_GENERATED_1";
})(IMessageGenerated = exports.IMessageGenerated || (exports.IMessageGenerated = {}));
var IMessageSecure;
(function (IMessageSecure) {
    IMessageSecure[IMessageSecure["MESSAGES_WILL_PROTECTED_IN_EMAIL_NOTIFICATIONS_0"] = 0] = "MESSAGES_WILL_PROTECTED_IN_EMAIL_NOTIFICATIONS_0";
    IMessageSecure[IMessageSecure["MESSAGE_WILL_DISPLAY_ENTIRELY_1"] = 1] = "MESSAGE_WILL_DISPLAY_ENTIRELY_1";
})(IMessageSecure = exports.IMessageSecure || (exports.IMessageSecure = {}));
var IMessageRead;
(function (IMessageRead) {
    IMessageRead[IMessageRead["MESSAGE_HAS_NOT_BEEN_READ_YET_0"] = 0] = "MESSAGE_HAS_NOT_BEEN_READ_YET_0";
    IMessageRead[IMessageRead["MESSAGE_HAS_BEEN_READ_AND_A_VALUE_1"] = 1] = "MESSAGE_HAS_BEEN_READ_AND_A_VALUE_1";
})(IMessageRead = exports.IMessageRead || (exports.IMessageRead = {}));
